import { forEach } from 'lodash';
import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { HOME_TYPE } from '../../../constants/service/app/widgetConstants';
import { SUB_PAGE_LIST_URL_PATH } from '../../../constants/service/common/urlConstants';
import widgetToastMsg from '../../../constants/service/toastMsg/widgetToastMsg';
import WidgetApi from '../../../lib/api/widget/WidgetApi';
import { _setResponseListForm, reDirectPage, setResponseListForm } from '../../../lib/common';
import { setRequestForm } from '../../../lib/common.js';
import toastMsg from '../../../lib/toastMsg';
import { setPreviewWidgetData } from '../../../lib/utils/widgetUtils';
import { _LIST_PAGINATION_MODEL } from '../app/models';
import widgetActions from './actions';
import { WIDGET_ALL_LIST_SEARCH_OPTION_MODEL } from './models';

function* fetchList() {
  /**
   * [메뉴 등록 및 편집] 메뉴 요청하기
   */
  yield takeEvery(widgetActions.GET_HOME_MENU_WIDGET_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(WidgetApi.getHomeMenu, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      const data = {
        homeMenu: result.data.homeMenu,
      };

      yield put({ type: widgetActions.GET_HOME_MENU_WIDGET_SUCCESS, payload: data });

      toastMsg.success(widgetToastMsg.GET_HOME_MENU_REQUEST_SUCCESS);
    } catch (error) {
      toastMsg.error(widgetToastMsg.GET_HOME_MENU_REQUEST_ERROR, error);
    }
  });

  /**
   *  [메뉴 등록 및 편집] 메뉴 업데이트
   */
  yield takeEvery(widgetActions.UPDATE_HOME_MENU_WIDGET_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(WidgetApi.updateHomeMenu, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      const data = {
        homeMenuItem: result.data.homeMenuItem,
      };

      toastMsg.success(widgetToastMsg.UPDATE_HOME_MENU_REQUEST_SUCCESS);

      yield put({ type: widgetActions.UPDATE_HOME_MENU_WIDGET_SUCCESS, payload: data });
    } catch (error) {
      toastMsg.error(widgetToastMsg.UPDATE_HOME_MENU_REQUEST_ERROR, error);
    }
  });

  /**
   *  [위젯 배너 아이템 등록] 브랜드 리스트 요청하기
   */
  yield takeEvery(widgetActions.GET_STORE_LIST_REQUEST, function* ({ payload }) {
    try {
      const { listPath, ...sendData } = payload;
      const result = yield call(WidgetApi.getStoreList, setRequestForm(sendData, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(widgetToastMsg.GET_STORE_LIST_REQUEST_SUCCESS);

        const data = {
          listData: setResponseListForm(result.data.widgetItemList, result.data.totalCnt, payload),
          selectedItem: result.data.selectedItem,
          listPath,
        };
        yield put({ type: widgetActions.GET_WIDGET_BANNER_ITEM_LINK_ID_ITEM_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(widgetToastMsg.GET_STORE_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [위젯 섹션 등록] 기획전 리스트 요청하기
   */
  yield takeEvery(widgetActions.GET_EVENT_LIST_REQUEST, function* ({ payload }) {
    try {
      const { listPath, ...sendData } = payload;
      const result = yield call(WidgetApi.getEventList, setRequestForm(sendData, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(widgetToastMsg.GET_EVENT_LIST_REQUEST_SUCCESS);

        const data = {
          listData: setResponseListForm(result.data.widgetItemList, result.data.totalCnt, payload),
          selectedItem: result.data.selectedItem,
          listPath,
        };
        yield put({ type: widgetActions.GET_WIDGET_BANNER_ITEM_LINK_ID_ITEM_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(widgetToastMsg.GET_EVENT_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [아이템 등록] 서브 페이지 리스트 요청하기
   */
  yield takeEvery(widgetActions.GET_MODAL_SUB_PAGE_LIST_REQUEST, function* ({ payload }) {
    try {
      const { listPath } = payload;
      const result = yield call(WidgetApi.getHomeList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(widgetToastMsg.GET_MODAL_HOME_LIST_REQUEST_SUCCESS);

      const data = {
        listData: setResponseListForm(result.data.widgetItemList, result.data.totalCnt, payload),
        listPath,
        selectedItem: result.data.selectedItem,
      };

      yield put({ type: widgetActions.GET_WIDGET_BANNER_ITEM_LINK_ID_ITEM_LIST_SUCCESS, payload: data });
    } catch (error) {
      toastMsg.error(widgetToastMsg.GET_MODAL_HOME_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [위젯 배너 아이템 등록] 상품 리스트 요청하기
   */
  yield takeEvery(widgetActions.GET_PRODUCT_LIST_REQUEST, function* ({ payload }) {
    try {
      const { listPath, ...sendData } = payload;
      const sortOption = {};
      forEach(sendData.sortOption, (item) => {
        sortOption[item.id] = item.desc ? 'descend' : false;
      });
      const newSendData = {
        ...sendData,
        sortOption,
      };
      const result = yield call(WidgetApi.getProductList, setRequestForm(newSendData, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(widgetToastMsg.GET_PRODUCT_LIST_REQUEST_SUCCESS);
        const data = {
          listData: setResponseListForm(result.data.widgetItemList, result.data.totalCnt, payload),
          listPath,
          selectedItem: result.data.selectedItem,
        };

        yield put({ type: widgetActions.GET_WIDGET_BANNER_ITEM_LINK_ID_ITEM_LIST_SUCCESS, payload: data });

        /**
         *  상품 1차 카테고리 리스트
         */
        if (result.data.mainProductCategorySelectList) {
          yield put(
            widgetActions.setData({
              path: ['widgetSave', 'mainProductCategorySelectList'],
              value: result.data.mainProductCategorySelectList,
            }),
          );
        }
        /**
         *  상품 1차 카테고리 리스트
         */
        if (result.data.subProductCategorySelectList) {
          yield put(
            widgetActions.setData({
              path: ['widgetSave', 'subProductCategorySelectList'],
              value: result.data.subProductCategorySelectList,
            }),
          );
        }
      }
    } catch (error) {
      toastMsg.error(widgetToastMsg.GET_PRODUCT_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   * [위젯 배너 아이템 등록] 후기 리스트 요청하기
   */
  yield takeEvery(widgetActions.GET_REVIEW_LIST_REQUEST, function* ({ payload }) {
    try {
      const { listPath } = payload;
      const result = yield call(WidgetApi.getReviewList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(widgetToastMsg.GET_REVIEW_LIST_REQUEST_SUCCESS);

      const data = {
        listData: setResponseListForm(result.data.widgetItemList, result.data.totalCnt, payload),
        listPath,
        selectedItem: result.data.selectedItem,
      };

      yield put({ type: widgetActions.GET_WIDGET_BANNER_ITEM_LINK_ID_ITEM_LIST_SUCCESS, payload: data });
    } catch (error) {
      toastMsg.error(widgetToastMsg.GET_REVIEW_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   * [위젯 배너 아이템 등록] 태그 리스트 요청하기
   */
  yield takeEvery(widgetActions.GET_TAG_LIST_REQUEST, function* ({ payload }) {
    try {
      const { listPath, ...sendData } = payload;
      const sortOption = {};
      forEach(sendData.sortOption, (item) => {
        sortOption[item.id] = item.desc ? 'descend' : false;
      });
      const newSendData = {
        ...sendData,
        sortOption,
      };
      const result = yield call(WidgetApi.getTagList, setRequestForm(newSendData, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(widgetToastMsg.GET_TAG_LIST_REQUEST_SUCCESS);

      const data = {
        listData: setResponseListForm(result.data.widgetItemList, result.data.totalCnt, payload),
        listPath,
        selectedItem: result.data.selectedItem,
      };

      yield put({ type: widgetActions.GET_WIDGET_BANNER_ITEM_LINK_ID_ITEM_LIST_SUCCESS, payload: data });
    } catch (error) {
      toastMsg.error(widgetToastMsg.GET_TAG_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [서브 페이지 등록] 서브 페이지 등록 요청하기
   */
  yield takeEvery(widgetActions.INSERT_SUB_PAGE_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(WidgetApi.insertSubPage, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      reDirectPage({ path: SUB_PAGE_LIST_URL_PATH });

      toastMsg.success(widgetToastMsg.INSERT_SUB_PAGE_REQUEST_SUCCESS);
    } catch (error) {
      toastMsg.error(widgetToastMsg.INSERT_SUB_PAGE_REQUEST_ERROR, error);
    }
  });

  /**
   * [서브 페이지] 서브 페이지 편집 요청하기
   */
  yield takeEvery(widgetActions.EDIT_SUB_PAGE_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(WidgetApi.editSubPage, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }
      toastMsg.success(widgetToastMsg.EDIT_SUB_PAGE_REQUEST_SUCCESS);
    } catch (error) {
      toastMsg.error(widgetToastMsg.EDIT_SUB_PAGE_REQUEST_ERROR, error);
    }
  });

  /**
   *  [서브 페이지] 서브 페이지 리스트 요청하기
   */
  yield takeEvery(widgetActions.GET_SUB_PAGE_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(WidgetApi.getSubPageList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(widgetToastMsg.GET_SUB_PAGE_LIST_REQUEST_SUCCESS);

        const data = {
          subPageList: _setResponseListForm(result.data.subPageList, result.data.totalCnt, payload),
        };

        yield put({ type: widgetActions.GET_SUB_PAGE_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(widgetToastMsg.GET_SUB_PAGE_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [서브 페이지 상태] 서브 페이지 상태 업데이트 요청하기
   */
  yield takeEvery(widgetActions.UPDATE_SUB_PAGE_STATUS_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(WidgetApi.updateSubPageStatus, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      const data = {
        status: payload.status,
        index: payload.index,
      };

      yield put({ type: widgetActions.UPDATE_SUB_PAGE_STATUS_SUCCESS, payload: data });

      toastMsg.success(widgetToastMsg.UPDATE_SUB_PAGE_STATUS_REQUEST_SUCCESS);
    } catch (error) {
      toastMsg.error(widgetToastMsg.UPDATE_SUB_PAGE_STATUS_REQUEST_ERROR, error);
    }
  });

  /**
   *  [서브 페이지 삭제] 서브 페이지 삭제 요청하기
   */
  yield takeEvery(widgetActions.DELETE_SUB_PAGE_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(WidgetApi.updateSubPageStatus, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      const data = {
        subPageId: payload.subPageId,
      };

      yield put({ type: widgetActions.DELETE_SUB_PAGE_SUCCESS, payload: data });

      toastMsg.success(widgetToastMsg.DELETE_SUB_PAGE_REQUEST_SUCCESS);
    } catch (error) {
      toastMsg.error(widgetToastMsg.DELETE_SUB_PAGE_REQUEST_ERROR, error);
    }
  });

  /**
   *  [메인 페이지 위젯 리스트] 메인 페이지 위젯 리스트 요청하기
   */
  yield takeEvery(widgetActions.GET_MAIN_PAGE_WIDGET_LIST_REQUEST, function* () {
    try {
      const result = yield call(WidgetApi.getPageWidgetList, setRequestForm(undefined, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(widgetToastMsg.GET_MAIN_PAGE_WIDGET_LIST_REQUEST_SUCCESS);

        const data = {
          pageWidgetList: result.data.pageWidgetList,
        };

        yield put({ type: widgetActions.GET_MAIN_PAGE_WIDGET_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(widgetToastMsg.GET_MAIN_PAGE_WIDGET_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [서브 페이지 위젯 리스트] 서브 페이지 위젯 리스트 요청하기
   */
  yield takeEvery(widgetActions.GET_SUB_PAGE_WIDGET_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(WidgetApi.getSubWidgetList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(widgetToastMsg.GET_SUB_PAGE_WIDGET_LIST_REQUEST_SUCCESS);

        const data = {
          pageWidgetList: result.data.pageWidgetList,
          pageInfo: result.data.pageInfo,
        };

        yield put({ type: widgetActions.GET_SUB_PAGE_WIDGET_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(widgetToastMsg.GET_SUB_PAGE_WIDGET_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [위젯 전체 리스트] 위젯 전체 리스트 요청하기
   */
  yield takeEvery(widgetActions.GET_WIDGET_ALL_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(WidgetApi.getWidgetAllList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(widgetToastMsg.GET_WIDGET_ALL_LIST_REQUEST_SUCCESS);

        const data = {
          widgetList: _setResponseListForm(result.data.widgetAllList, result.data.totalCnt, payload),
        };

        yield put({ type: widgetActions.GET_WIDGET_ALL_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(widgetToastMsg.GET_WIDGET_ALL_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [위젯 비활성 리스트] 위젯 비활성 리스트 요청하기
   */
  yield takeEvery(widgetActions.GET_WIDGET_INACTIVE_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(WidgetApi.getWidgetInactiveList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(widgetToastMsg.GET_WIDGET_INACTIVE_LIST_REQUEST_SUCCESS);

        const data = {
          widgetInactiveList: _setResponseListForm(result.data.widgetInactiveList, result.data.totalCnt, payload),
        };

        yield put({ type: widgetActions.GET_WIDGET_INACTIVE_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(widgetToastMsg.GET_WIDGET_INACTIVE_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [위젯 리스트] 변경된 위젯 리스트 저장하기
   */
  yield takeEvery(widgetActions.SAVE_UPDATED_WIDGET_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(WidgetApi.saveUpdatedWidgetList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(widgetToastMsg.SAVE_UPDATED_WIDGET_LIST_REQUEST_SUCCESS);

        /**
         *  위젯 리스트 갱신하기
         */
        if (payload.homeType === HOME_TYPE.MAIN) {
          // 메인 페이지 위젯 리스트 불러오기
          yield put({ type: widgetActions.GET_MAIN_PAGE_WIDGET_LIST_REQUEST });
        } else {
          // 서브 페이지 위젯 리스트 불러오기
          yield put({
            type: widgetActions.GET_SUB_PAGE_WIDGET_LIST_REQUEST,
            payload: {
              homeId: payload.homeId,
            },
          });
        }
      }
    } catch (error) {
      toastMsg.error(widgetToastMsg.SAVE_UPDATED_WIDGET_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [위젯 리스트] 변경된 전체 위젯 리스트 저장하기
   */
  yield takeEvery(widgetActions.SAVE_UPDATED_ALL_WIDGET_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(WidgetApi.saveUpdatedAllWidgetList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(widgetToastMsg.SAVE_UPDATED_ALL_WIDGET_LIST_REQUEST_SUCCESS);

        /**
         *  전체 위젯 리스트 갱신하기
         */
        yield put({
          type: widgetActions.GET_WIDGET_ALL_LIST_REQUEST,
          payload: {
            searchOption: WIDGET_ALL_LIST_SEARCH_OPTION_MODEL,
            pagination: _LIST_PAGINATION_MODEL,
          },
        });
      }
    } catch (error) {
      toastMsg.error(widgetToastMsg.SAVE_UPDATED_ALL_WIDGET_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [위젯 리스트] 위젯 미리보기 데이터 요청하기
   */
  yield takeEvery(widgetActions.GET_WIDGET_PREVIEW_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(WidgetApi.getWidgetPreviewData, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(widgetToastMsg.GET_WIDGET_PREVIEW_DATA_REQUEST_SUCCESS);

        const { widgetInfo, selectedWidgetItemList, exposureWidgetItemList, widgetProductTypeInfo, widgetDetail } =
          result.data.widgetData;

        const widgetPreviewData = setPreviewWidgetData(
          widgetInfo,
          selectedWidgetItemList.list,
          exposureWidgetItemList,
          widgetProductTypeInfo,
          widgetDetail,
        );

        const data = {
          name: 'widgetPreviewModal',
          value: true,
          data: {
            widgetPreviewData,
          },
        };
        yield put({ type: widgetActions.TOGGLE_MODAL, payload: data });
      }
    } catch (error) {
      toastMsg.error(widgetToastMsg.GET_WIDGET_PREVIEW_DATA_REQUEST_ERROR, error);
    }
  });

  /**
   *  [위젯 리스트] 위젯 미리보기 비교 데이터 요청하기
   */
  yield takeEvery(widgetActions.GET_WIDGET_PREVIEW_COMPARE_DATA_REQUEST, function* ({ payload }) {
    try {
      const { pageWidgetList } = payload;
      const result = yield call(
        WidgetApi.getWidgetPreviewCompareData,
        setRequestForm(
          {
            pageWidgetIdList: pageWidgetList.map((item) => item.id),
          },
          true,
        ),
      );
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(widgetToastMsg.GET_WIDGET_PREVIEW_PERIOD_DATA_REQUEST_SUCCESS);
        const { pageWidgetDataList } = result.data;
        let targetWidgetData;
        let pageWidgetPreviewDataList = pageWidgetDataList.map((widgetData) => {
          const { widgetInfo, selectedWidgetItemList, exposureWidgetItemList, widgetProductTypeInfo, widgetDetail } =
            widgetData;

          targetWidgetData = pageWidgetList.find((item) => item.id === widgetInfo.id);
          if (targetWidgetData) {
            widgetInfo.exposureStartDate = targetWidgetData.exposureStartDate;
            widgetInfo.exposureEndDate = targetWidgetData.exposureEndDate;
          }

          return setPreviewWidgetData(
            widgetInfo,
            selectedWidgetItemList.list,
            exposureWidgetItemList,
            widgetProductTypeInfo,
            widgetDetail,
          );
        });

        const data = {
          name: 'widgetPreviewCompareModal',
          value: true,
          data: {
            pageWidgetPreviewDataList,
          },
        };
        yield put({ type: widgetActions.TOGGLE_MODAL, payload: data });
      }
    } catch (error) {
      toastMsg.error(widgetToastMsg.GET_WIDGET_PREVIEW_PERIOD_DATA_REQUEST_ERROR, error);
    }
  });
}

export default function* widgetSaga() {
  yield fork(fetchList);
}
